import { i as proxyUrlToAbsoluteURL, n as isProxyUrlRelative, r as isValidProxyUrl, t as isHttpOrHttps } from "./proxy-BcfViKjn.mjs";

export { isHttpOrHttps, isProxyUrlRelative, isValidProxyUrl, proxyUrlToAbsoluteURL };